import { render, staticRenderFns } from "./RequestDetailActivity.vue?vue&type=template&id=3ca39bee"
import script from "./RequestDetailActivity.vue?vue&type=script&lang=js"
export * from "./RequestDetailActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports